import { render, staticRenderFns } from "./ImageConfig.vue?vue&type=template&id=966387e0"
import script from "./ImageConfig.vue?vue&type=script&lang=js"
export * from "./ImageConfig.vue?vue&type=script&lang=js"
import style0 from "./ImageConfig.vue?vue&type=style&index=0&id=966387e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports